export function formatDateForSplit(dateOrUndefined: string | undefined) {
  return dateOrUndefined && !Number.isNaN(Date.parse(dateOrUndefined))
    ? new Date(dateOrUndefined).getTime()
    : 1000;
}
